export function LoadingBlock({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="flex items-center gap-3 py-12 text-foreground-600">
      <span className="w-5 h-5 flex items-center justify-center animate-spin"><i className="ri-loader-4-line"></i></span>
      <span className="font-label uppercase tracking-widest text-sm">{label}...</span>
    </div>
  );
}

export function ErrorBlock({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div className="py-12 flex flex-col items-start gap-3">
      <p className="text-foreground-700">{message || 'Something went wrong loading this section.'}</p>
      <button type="button" onClick={onRetry} className="bg-primary-500 hover:bg-primary-600 text-background-50 font-label font-bold uppercase tracking-wider px-5 py-2.5 rounded-md whitespace-nowrap cursor-pointer">Try again</button>
    </div>
  );
}